import TransferenciaEntradaView from "./TransferenciaEntradaView";
export default TransferenciaEntradaView;